import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Form
} from "reactstrap";
import { ContenidoService } from "service/ContenidoService";
import FDateInput from "components/DateInput/FDateInput";
import FSelect from "components/Select/FSelect";

const ModalTema = ({ isOpen, toggle, selectedTema, cursoId, onSave }) => {
  const [tema, setTema] = useState({
    titulo: "",
    descripcion: "",
    ciclo: localStorage.getItem("_c") || "",
    semana_id: localStorage.getItem("_s") || "1",
    urlvideo: "https://player.vimeo.com/video/",
    urlchat: "https://vimeo.com/live-chat/",
    estado: "Publicado",
    endirecto: false,
    fecha: "",
    horainicio: "",
    horafin: ""
  });

  const [listCiclos, setListCiclos] = useState([]);
  const contenidoService = new ContenidoService();

  const semanas = Array.from({ length: 20 }, (_, i) => ({ id: `${i + 1}`, nombre: `Semana ${i + 1}` }));

  useEffect(() => {
    loadInitialData();
  }, []);

  useEffect(() => {
    if (isOpen) {
      if (selectedTema) {
        setTema({
          ...selectedTema,
          ciclo: selectedTema.ciclo?._id || selectedTema.ciclo || "",
          semana_id: selectedTema.semana_id?._id || selectedTema.semana_id || "1",
          fecha: selectedTema.fecha ? selectedTema.fecha.split('T')[0] : "",
          horainicio: selectedTema.horainiciomin ? minutesToTime(selectedTema.horainiciomin) : "",
          horafin: selectedTema.horafinmin ? minutesToTime(selectedTema.horafinmin) : ""
        });
      } else {
        setTema({
          titulo: "",
          descripcion: "",
          ciclo: localStorage.getItem("_c") || "",
          semana_id: localStorage.getItem("_s") || "1",
          urlvideo: "https://player.vimeo.com/video/",
          urlchat: "https://vimeo.com/live-chat/",
          estado: "Publicado",
          endirecto: false,
          fecha: "",
          horainicio: "",
          horafin: ""
        });
      }
    }
  }, [isOpen, selectedTema]);

  const loadInitialData = async () => {
    try {
      const res = await contenidoService.getCiclos();
      setListCiclos(res?.data || []);
    } catch (error) {
      console.error("Error cargando ciclos:", error);
    }
  };

  const minutesToTime = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  const timeToMinutes = (timeString) => {
    if (!timeString) return null;
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setTema(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSave = async () => {
    try {
      const dto = { 
        ...tema, 
        curso: cursoId,
        horainiciomin: timeToMinutes(tema.horainicio),
        horafinmin: timeToMinutes(tema.horafin)
      };

      if (tema.ciclo) localStorage.setItem("_c", tema.ciclo);
      if (tema.semana_id) localStorage.setItem("_s", tema.semana_id);

      let res;
      if (tema._id) {
        res = await contenidoService.updateTema(dto);
      } else {
        res = await contenidoService.addTema(dto);
      }

      if (res?.confirmation === "success") {
        alert("Tema guardado exitosamente");
        onSave();
        toggle();
      }
    } catch (error) {
      console.error("Error guardando tema:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
      <ModalHeader toggle={toggle}>
        {tema._id ? "Editar Tema" : "Nuevo Tema"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col md="8">
              <FormGroup>
                <Label>Título del Tema</Label>
                <Input name="titulo" value={tema.titulo} onChange={handleChange} />
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label>Estado</Label>
                <FSelect
                  name="estado"
                  value={tema.estado}
                  onChange={handleChange}
                  options={[
                    { value: "Publicado", label: "Publicado" },
                    { value: "Borrador", label: "Borrador" },
                    { value: "Oculto", label: "Oculto" },
                  ]}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Ciclo</Label>
                <FSelect
                  name="ciclo"
                  value={tema.ciclo}
                  onChange={handleChange}
                  options={listCiclos.map(c => ({ value: c._id, label: c.denominacion }))}
                  placeholder="Seleccione Ciclo"
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Semana</Label>
                <FSelect
                  name="semana_id"
                  value={tema.semana_id}
                  onChange={handleChange}
                  options={semanas.map(s => ({ value: s.id, label: s.nombre }))}
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>Descripción</Label>
            <Input type="textarea" name="descripcion" value={tema.descripcion} onChange={handleChange} rows="3" />
          </FormGroup>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>URL Video (Vimeo)</Label>
                <Input name="urlvideo" value={tema.urlvideo} onChange={handleChange} />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>URL Chat (Vimeo)</Label>
                <Input name="urlchat" value={tema.urlchat} onChange={handleChange} />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup check className="mb-3 ml-3">
            <Label check>
              <Input type="checkbox" name="endirecto" checked={tema.endirecto} onChange={handleChange} />{" "}
              ¿Es una transmisión en directo?
            </Label>
          </FormGroup>

          {tema.endirecto && (
            <Row className="bg-light p-2 rounded ml-1 mr-1">
              <Col md="4">
                <FormGroup>
                  <Label>Fecha</Label>
                  <FDateInput name="fecha" value={tema.fecha} onChange={handleChange} />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Hora Inicio</Label>
                  <Input type="time" name="horainicio" value={tema.horainicio} onChange={handleChange} />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Hora Fin</Label>
                  <Input type="time" name="horafin" value={tema.horafin} onChange={handleChange} />
                </FormGroup>
              </Col>
            </Row>
          )}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
        <Button color="primary" onClick={handleSave}>Guardar Tema</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalTema;
